import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./arrowPopup.styles";
export function ArrowPopup({ children }) {
    return (_jsx(S.PseudoWrapper, { children: _jsx(S.Popup, { children: children }) }));
}
